// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6918cdcd","805":"37a145f8"}[chunkId] + ".chunk.js";
};